import React from 'react';
import {connect} from 'react-redux';

import {dynamic as loadable} from 'components/__helpers/dynamic/dynamic';
import {ApplicationStoreType} from 'reducers';

import {AuthorizationConnected} from '../authorization/authorization';

const AccountConnectedDynamic = loadable(
    () => import(/* webpackChunkName: "accountConnectedDynamic" */ '../account/account'),
    'AccountConnectedDynamic',
);

export type PropsType = {
    isLogged: boolean;
    isOpened: boolean;
    isMenuOpened: boolean;
};

/**
 *  Functional-component for AccountActions
 *  @param {PropsType} props - Received props
 *  @returns {Node} - Rendered AccountActions stateless component
 */
export const AccountActions = ({isLogged, isOpened = false, isMenuOpened}: PropsType) =>
    isLogged ? (
        <AccountConnectedDynamic isOpened={isOpened} />
    ) : (
        <AuthorizationConnected isOpened={isOpened} isMenuOpened={isMenuOpened} />
    );

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
export const mapStateToProps = (store: ApplicationStoreType) => ({
    isLogged: store.customer.is_logged_in,
});

export const AccountActionsConnected = connect(mapStateToProps)(AccountActions);
